import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { UserContext } from '../context/authContext';
import React, { useContext, useEffect } from 'react';
import Cookeis from 'js-cookie';

export const ProtectedRoute = (): any => {
  const { token, setToken } = useContext(UserContext);
  const navigate = useNavigate();
  const localToken = Cookeis.get('token');
  useEffect(() => {
    if (localToken) {
      setToken(localToken);
    }
  }, []);
  const location = useLocation();
  console.log('in protected route', location);
  useEffect(() => {
    if (!token && !localToken) {
      //user is not authenticated
      console.log('no token redirecting');
      return navigate('/login', {
        state: { pathname: location.pathname, search: location.search }
      });
    }
  }, []);
  return (
    <>
      <Outlet />
    </>
  );
};
